<template>
	<el-dialog
		:modal-append-to-body="true"
		:append-to-body="true"
		class="tipsDialog"
		:visible.sync="dialogVisible"
		width="400px">
		<template #title>
			<div style="display: flex; align-items: center">
				<i class="el-icon-warning" style="color: #eaa74d; font-size: 24px; margin-right: 5px"></i>
				<span>{{ $t('theme.list.767480-2') }}</span>
			</div>
		</template>
		<div style="display: flex; align-items: center">
			{{ $t('theme.list.767480-3') }}
		</div>
		<div style="margin-top: 10px">
			<el-checkbox v-model="noTips" true-label="1" false-label="0">
				{{ $t('theme.list.767480-4') }}
			</el-checkbox>
		</div>
		<span slot="footer" class="dialog-footer">
			<el-button size="small" @click="dialogVisible = false">{{ $t('theme.list.767480-5') }}</el-button>
			<el-button size="small" type="primary" @click="$emit('confirm')">
				{{ $t('theme.list.767480-6') }}
			</el-button>
		</span>
	</el-dialog>
</template>

<script>
export default {
	name: "ThemeChangeTemplateDialog",
	props: {
		visible: {
			type: Boolean,
			required: true,
		},
		noTipsChangeTemplate: {
			type: String,
			required: true,
		},
	},
	computed: {
		dialogVisible: {
			get() {
				return this.visible;
			},
			set(value) {
				this.$emit("update:visible", value);
			},
		},
		noTips: {
			get() {
				return this.noTipsChangeTemplate;
			},
			set(value) {
				this.$emit("update:noTipsChangeTemplate", value);
			},
		},
	},
};
</script>
